module.exports = __webpack_public_path__ + "static/cag3-10a6b4bd020e1ffbaa1583d01952255e.png";